import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Swap, TrainVideos, User } from '../../assests/ExportImageIcon'
import MainTab from '../../componants/mainTab/MainTab'
import PopularDestination from '../popularDestination/PopularDestination'
import SpecialOffer from '../specialOffer/SpecialOffer'
import InfluencerReels from '../influencerReels/InfluencerReels'
import GetApp from '../getApp/GetApp'
import OurLatestBlog from '../ourLatestblog/OurLatestBlog'
import TrainStationAutocomplete from '../../componants/trainStationAutocomplete/TrainStationAutocomplete'
import DatePicker from '../../componants/datePicker/DatePicker'
import service from '../../services/service'
import endpoints from '../../services/endpoints'
import { showToast } from '../../componants/toast/toastService'
import { setTrainSearchParams, setTrainSearching, setTrainResults } from '../../redux/trainSearch/trainSearchSlice'
// .travellerCheckRow (green accent-color checkbox row) is defined here — reused
// as-is for the concession checkboxes below instead of writing a new class.
import '../cruise/cruiseAllBookingDetails/cruiseBookingDetail.css'

// FROM/TO (GET /trains/station-codes/), CLASS (GET /trains/class-quota/) and
// DEPARTURE (real DatePicker) are all wired. Concessions checkboxes stay
// static — no matching field on any of these APIs. Reuses the exact same
// .searchInput/.flightSearchInner/.swapIcon/.flightClass classes (and the
// same real <select> pattern flight.jsx uses inside .flightClass) — no new
// CSS for the search bar.
const CONCESSIONS = [
    'Person with Disability Concession',
    'Flexible with Dates',
    'Railway Pass Concession',
]

const todayIso = () => new Date().toISOString().split('T')[0]

// /trains/train-list/ takes date as dd-mm-yyyy, not the DatePicker's iso yyyy-mm-dd.
const toApiDate = (iso) => {
    const [y, m, d] = iso.split('-')
    return `${d}-${m}-${y}`
}

const Train = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [fromStation, setFromStation] = useState(null)
  const [toStation, setToStation] = useState(null)
  const [departureDate, setDepartureDate] = useState(todayIso())
  const [classes, setClasses] = useState([])
  const [selectedClass, setSelectedClass] = useState('')

  useEffect(() => {
    service
        .get(endpoints.trains.classQuota, {}, { silent: true })
        .then(({ data }) => setClasses((data.data || []).filter((item) => item.type === 'class')))
        .catch(() => {})
  }, [])

  const swapStations = () => {
    setFromStation(toStation)
    setToStation(fromStation)
  }

  const handleSearch = () => {
    if (!fromStation?.code || !toStation?.code) {
        showToast('Please enter both from and to stations', 'error')
        return
    }
    if (!departureDate) {
        showToast('Please select a departure date', 'error')
        return
    }

    dispatch(setTrainSearchParams({ origin: fromStation, destination: toStation, date: departureDate }))
    dispatch(setTrainResults(null))
    dispatch(setTrainSearching(true))
    navigate('/train-list')

    // Search runs in the background; the results page shows a loader
    // (driven by isSearching) until results land in the store.
    // /trains/train-list/ has no class/quota param — selectedClass is UI-only for now.
    ;(async () => {
        try {
            const { data } = await service.get(endpoints.trains.list, {
                origin: fromStation.code,
                destination: toStation.code,
                date: toApiDate(departureDate),
                page: 1,
                page_size: 10,
            }, { silent: true })
            dispatch(setTrainResults(data))
        } catch {
            // error toast already shown by the service interceptor
        } finally {
            dispatch(setTrainSearching(false))
        }
    })()
  }

  return (
    <>
        <section className='banner'>
            <div className='videoPart'>
                <video className='promoBanner' autoPlay loop muted playsinline="" data-object-fit="cover" preload="metadata">
                    <source src={TrainVideos} type="video/mp4" />
                </video>
            </div>
            <div className='bannerContent'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <h1>Book Your Train With Just One Click</h1>
                            <MainTab />
                        </div>
                        <div className='col-md-12'>
                            <div className='bookingAreaanner'>
                                <div className='searchFlightArea'>
                                    <div className='flightSearchUp'>
                                        <div className='flightSearchInner'>
                                            <div className='searchInput'>
                                                <TrainStationAutocomplete
                                                    label="FROM"
                                                    placeholder="Enter City or Station"
                                                    value={fromStation}
                                                    onChange={setFromStation}
                                                    excludeCode={toStation?.code}
                                                />
                                            </div>
                                            <div className='swapIcon' onClick={swapStations}>
                                                <img src={Swap} alt="Swap" />
                                            </div>
                                            <div className='searchInput'>
                                                <TrainStationAutocomplete
                                                    label="TO"
                                                    placeholder="Enter City or Station"
                                                    value={toStation}
                                                    onChange={setToStation}
                                                    excludeCode={fromStation?.code}
                                                />
                                            </div>
                                        </div>
                                        <div className='searchInput cmnBdr'>
                                            <div>
                                                <label>DEPARTURE</label>
                                                <DatePicker
                                                    className='searchBarDateField'
                                                    min={todayIso()}
                                                    value={departureDate}
                                                    onChange={setDepartureDate}
                                                />
                                            </div>
                                        </div>
                                        <div className='flightClass'>
                                            <div className='searchInput'>
                                                <img src={User} alt="" />
                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                    <label>CLASS</label>
                                                    <select value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)}>
                                                        <option value=''>All Classes</option>
                                                        {classes.map((c) => (
                                                            <option key={c.code} value={c.code}>{c.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ borderTop: '1px solid #DEE8EF', margin: '20px 0' }} />

                                    <div className='flightSearchDown'>
                                        <div className='searchBtn'>
                                            {CONCESSIONS.map((label) => (
                                                <label className='travellerCheckRow' key={label} style={{ marginTop: 0 }}>
                                                    <input type='checkbox' />
                                                    {label}
                                                </label>
                                            ))}
                                        </div>
                                        <button type='button' className='commonBtn' onClick={handleSearch}>
                                            Search Train
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <PopularDestination />

        <SpecialOffer />

        <InfluencerReels />

        <GetApp />

        <OurLatestBlog />
    </>
  )
}

export default Train
